import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppScreenShell from "../../components/layout/AppScreenShell";
import InstallInstructions from "../../components/pwa/InstallInstructions";
import { usePWAInstall } from "../../components/pwa/PWAInstallContext";

export default function InstallAndroid() {
  const navigate = useNavigate();
  const { canInstall, installed, busy, install } = usePWAInstall();
  const [notice, setNotice] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNativeInstall = async () => {
    if (!canInstall || busy) return;
    const result = await install();
    if (result === "accepted" || result === "installed") {
      setNotice("Installation accepted. You can open Gwin from your Home Screen once it finishes.");
    } else {
      setNotice("Please use the browser menu and follow the steps below.");
    }
  };

  return (
    <AppScreenShell
      eyebrow="Install Gwin"
      title="Android installation"
      subtitle="Add Gwin to your Home Screen."
      maxWidth="max-w-[430px]"
      showBottomBar={false}
    >
      <section className="rounded-[24px] border border-[#E7E7E7] bg-white p-5 shadow-sm">
        {installed ? (
          <p className="mb-4 rounded-xl bg-[#EDF9F1] p-3 text-sm font-bold text-green-800">
            Gwin is already running as an installed app.
          </p>
        ) : canInstall ? (
          <button
            type="button"
            disabled={busy}
            onClick={handleNativeInstall}
            className="mb-5 min-h-[48px] w-full rounded-2xl bg-[#FF914D] px-4 py-3 text-sm font-black text-white disabled:opacity-50"
          >
            {busy ? "Opening installer..." : "Install Gwin"}
          </button>
        ) : null}
        {notice && <p role="status" className="mb-4 rounded-xl bg-[#FFF4EC] p-3 text-sm font-semibold text-[#6B5A4C]">{notice}</p>}
        <InstallInstructions device="android" />
      </section>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="mt-5 rounded-xl border border-[#DDDDDD] bg-white px-5 py-3 text-sm font-bold text-[#555555]"
      >
        Back
      </button>
    </AppScreenShell>
  );
}
